import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../utils/backButton";
import { MoneyPicker } from "./partials/moneyPicker";
import { PastTransactions } from "./partials/pastTransactions";
import { getTransactions, loadUserData, loadUsers } from "./partials/loadData";
import { Players } from "./partials/players";
import { Pay } from "./partials/pay";
import { GetGlobalColor } from "../utils/globalColors";
import Spinner from '../utils/spinner';

const Banc = () => {
  const [users, setUsers] = useState([]);
  const [recipient, setRecipient] = useState();
  const [sum, setSum] = useState(0);
  const navigate = useNavigate();
  const token = localStorage.getItem('userToken');
  const gameId = localStorage.getItem('gameId');
  const [admin, setAdmin] = useState();
  const [transactions, setTransactions] = useState([]);
  const color = GetGlobalColor();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      await loadUsers(token, gameId, setUsers);
      await loadUserData(token, gameId, setAdmin);
      await getTransactions(gameId, setTransactions);
      setLoading(false);
    };

    loadData();
  }, [token, gameId]);



  const handleSubmit = async () => {

    if ((sum <= 0 || !sum) && recipient != null) {
      return
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/pay`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ recipient: recipient, sum: sum, gameId: gameId, user: "Mono Bank" })
      });

      await response.json();

      navigate("/Game");


    } catch (error) {
      console.error("Error calling API:", error);
    }
  };


  return (
    <div className={`app-bg-${color} bg-overwrite`}>
      {loading &&
        <Spinner />
      }
      {admin ? (
        <>
          <BackButton to="/game" />
          <div className="card">
            <div className={`sub-card card-bg-${color}`}>
              <p className="wtext text-5xl mb-10">BANKA</p>

              <MoneyPicker setSum={setSum} sum={sum} />

              <Players
                users={users}
                recipient={recipient}
                setRecipient={setRecipient}
              />

              <Pay handleSubmit={handleSubmit} />

              <div className="transaction mt-5 h-[200px] overflow-y-auto">
                <PastTransactions
                  transactions={transactions}
                  player="Mono Bank"
                />
              </div>
            </div>
          </div>

        </>
      ) : (
        <div className="flex flex-col items-center text-center w-full h-screen pt-20">
          <p className="wtext text-xl mb-10">Ti nisi banka!</p>
        </div>
      )}
    </div>
  )
};

export default Banc;
